/**
 * AthleteSwap – gemeinsames Verhalten für kleine Produkt-Info-Tooltips.
 * Desktop: kurzer Hover, Klick/Tastatur; Mobile: Tap. Die Details bleiben
 * nativ bedienbar, das Script ergänzt nur konsistente Zustandslogik.
 */
(() => {
  const begriffe = [...document.querySelectorAll('[data-as-info-begriff]')];
  const tooltipSelector = '[data-as-info-tooltip]';
  const hoverFaehig = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const zeitgeber = new WeakMap();

  function detailsVon(begriff) {
    return begriff.querySelector(tooltipSelector);
  }

  function schliesse(details) {
    if (!details) return;
    window.clearTimeout(zeitgeber.get(details));
    details.open = false;
    delete details.dataset.asInfoFixiert;
  }

  function schliesseAlle(ausnahme = null) {
    document.querySelectorAll(tooltipSelector).forEach((details) => {
      if (details !== ausnahme) schliesse(details);
    });
  }

  function oeffne(details, fixiert = false) {
    if (!details) return;
    schliesseAlle(details);
    details.open = true;
    if (fixiert) details.dataset.asInfoFixiert = 'true';
  }

  begriffe.forEach((begriff) => {
    const details = detailsVon(begriff);
    const summary = details?.querySelector('summary');
    if (!details || !summary) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.open && details.dataset.asInfoFixiert === 'true') {
        schliesse(details);
      } else {
        oeffne(details, true);
      }
    });

    if (hoverFaehig) {
      begriff.addEventListener('pointerenter', () => {
        if (details.dataset.asInfoFixiert === 'true') return;
        zeitgeber.set(details, window.setTimeout(() => oeffne(details), 140));
      });
      begriff.addEventListener('pointerleave', () => {
        window.clearTimeout(zeitgeber.get(details));
        if (details.dataset.asInfoFixiert !== 'true') schliesse(details);
      });
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest('[data-as-info-begriff]')) schliesseAlle();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') schliesseAlle();
  });
})();
